import React, { Component } from 'react';

class GuestList extends Component {
    constructor(props){
        super(props);
    }

    render() {

        if (this.props.guests != undefined && this.props.guests != null) {
                const listGuests = this.props.guests.map((guest, index) => 
                <li key={index}>{guest}</li>
            );

            return (
                <ul>{listGuests}</ul>
            );

        } else {
            return (<ul><li>No Guests</li></ul>);
        }
    }
}

export default GuestList;


// WEBPACK FOOTER //
// ./src/components/GuestList.js